// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.test-result .ant-collapse {
  border: none;
  background: none;
  border-radius: 0.0625rem;
  box-shadow: none;
}
.test-result .ant-collapse-header {
  background: rgba(0, 0, 0, 0.08);
  border-radius: 0.0625rem;
  padding: 0.0625rem !important;
  border-bottom: none !important;
  display: flex !important;
  align-items: center !important;
}
.test-result .ant-collapse-header .ant-collapse-expand-icon {
  height: auto;
  padding-inline-end: 0.05rem !important;
}
.test-result .ant-collapse-header .ant-collapse-expand-icon span {
  max-width: 0.1125rem;
}
.test-result .ant-collapse-content {
  border: none;
}
.test-result .ant-collapse-content-box {
  padding: 0.0625rem 0.0625rem 0 0.0625rem !important;
}
.test-result .ant-collapse-item {
  border: none;
  margin-bottom: 0.125rem;
}
.test-result .ant-collapse-item:last-child .ant-collapse-header {
  border-radius: 0.0625rem;
}
.test-result .ant-collapse-item-disabled .ant-collapse-header {
  color: rgba(0, 0, 0, 0.88);
}
.test-result .ant-collapse-item-disabled .ant-collapse-content {
  display: none;
}
.test-result .ant-collapse-item .ant-collapse-header[aria-disabled=true] {
  pointer-events: none; /* 禁用 hover 效果 */
}
.test-result .ant-collapse .ant-badge .ant-badge-count {
  box-shadow: none;
  background: rgba(84, 100, 160, 0.5);
}
.test-result-collapse-header {
  display: flex;
  justify-content: space-between;
  align-items: center !important;
  font-size: 0.1rem;
  height: auto;
}
.test-result-collapse-header .anticon {
  color: rgba(0, 0, 0, 0.4);
  margin-right: 0.03125rem;
  font-size: 0.1rem;
}
.test-result-collapse-result {
  margin: 0.0625rem 0;
  border: 0.00625rem solid rgba(5, 5, 5, 0.1) !important;
}
.test-result-collapse-result .ant-collapse-body,
.test-result-collapse-result .ant-card-body {
  padding: 0.0625rem;
}
.test-result-collapse-result-box {
  display: flex;
  justify-content: space-between;
  font-size: 0.0875rem;
}
.test-result-collapse-result-loading-icon {
  color: #8b8589;
}
.test-result-collapse-result-passed {
  border: 0.00625rem solid rgb(125, 239, 162) !important;
  background-color: rgb(236, 253, 241) !important;
}
.test-result-collapse-result-passed-icon {
  color: rgb(36, 190, 76);
}
.test-result-collapse-result-passed-details .ant-collapse-header {
  background: transparent;
  font-size: 0.1rem;
  padding: 0 !important;
}
.test-result-collapse-result-passed-details .ant-collapse-header-text {
  display: block;
}
.test-result-collapse-result-passed-details .ant-collapse-header-text div {
  display: flex;
  justify-content: space-between;
}
.test-result-collapse-result-passed-details .ant-collapse-expand-icon {
  height: auto !important;
  padding-inline-end: 0.03125rem !important;
  margin-top: 0.03125rem;
}
.test-result-collapse-result-passed-details .ant-collapse-expand-icon span {
  max-width: 0.075rem !important;
}
.test-result-collapse-result-passed-details .ant-collapse-content {
  background: transparent;
}
.test-result-collapse-result-passed-details .ant-collapse-item {
  margin-bottom: 0;
}
.test-result-collapse-result-passed-details li {
  list-style: none;
  color: rgb(36, 190, 76);
  font-size: 0.0875rem;
  background: rgba(255, 255, 255, 0.5);
  padding: 0.0125rem 0.03125rem;
  border-radius: 0.0375rem;
  margin-top: 0.01875rem;
}
.test-result-collapse-result-collapse-badge .ant-scroll-number {
  background: rgba(75, 85, 99, 0.5) !important;
}
.test-result-collapse-result-error {
  border: 0.00625rem solid rgb(253, 189, 191) !important;
  background: rgb(254, 239, 239) !important;
}
.test-result-collapse-result-error-icon {
  color: rgb(233, 43, 53);
}
.test-result-collapse-result-error-details .ant-collapse-header {
  background: transparent;
  font-size: 0.1rem;
  padding: 0 !important;
}
.test-result-collapse-result-error-details .ant-collapse-header-text {
  display: block;
}
.test-result-collapse-result-error-details .ant-collapse-header-text div {
  display: flex;
  justify-content: space-between;
}
.test-result-collapse-result-error-details .ant-collapse-expand-icon {
  height: auto !important;
  padding-inline-end: 0.03125rem !important;
}
.test-result-collapse-result-error-details .ant-collapse-expand-icon span {
  max-width: 0.075rem !important;
}
.test-result-collapse-result-error-details .ant-collapse-content {
  background: transparent;
}
.test-result-collapse-result-error-details .ant-collapse-item {
  margin-bottom: 0;
}
.test-result-collapse-result-error-details li {
  list-style: none;
  color: rgb(209, 15, 29);
  font-size: 0.0875rem;
  background: rgba(255, 255, 255, 0.5);
  padding: 0.0125rem 0.03125rem;
  border-radius: 0.0375rem;
  margin-top: 0.01875rem;
}
.test-result .ant-collapse-arrow {
  font-size: 0.0625rem !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/component/testResult/index.scss"],"names":[],"mappings":"AAAA,gBAAgB;AACd;EACE,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;AACJ;AAAI;EACE,+BAAA;EACA,wBAAA;EACA,6BAAA;EACA,8BAAA;EACA,wBAAA;EACA,8BAAA;AAEN;AADM;EACE,YAAA;EACA,sCAAA;AAGR;AAFQ;EACE,oBAAA;AAIV;AAAI;EACE,YAAA;AAEN;AADM;EACE,mDAAA;AAGR;AAAI;EACE,YAAA;EACA,uBAAA;AAEN;AAAQ;EACE,wBAAA;AAEV;AAEQ;EACE,0BAAA;AAAV;AAEQ;EACE,aAAA;AAAV;AAGM;EACE,oBAAA,EAAA,gBAAA;AADR;AAII;EACE,gBAAA;EACA,mCAAA;AAFN;AAKE;EACE,aAAA;EACA,8BAAA;EACA,8BAAA;EACA,iBAAA;EACA,YAAA;AAHJ;AAII;EACE,yBAAA;EACA,wBAAA;EACA,iBAAA;AAFN;AAKE;EACE,mBAAA;EACA,sDAAA;AAHJ;AAII;;EAEE,kBAAA;AAFN;AAII;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;AAFN;AAKM;EACE,cAAA;AAHR;AAMI;EACE,sDAAA;EACA,+CAAA;AAJN;AAKM;EACE,uBAAA;AAHR;AAMQ;EACE,uBAAA;EACA,iBAAA;EACA,qBAAA;AAJV;AAKU;EACE,cAAA;AAHZ;AAIY;EACE,aAAA;EACA,8BAAA;AAFd;AAMQ;EACE,uBAAA;EACA,yCAAA;EACA,sBAAA;AAJV;AAKU;EACE,8BAAA;AAHZ;AAMQ;EACE,uBAAA;AAJV;AAMQ;EACE,gBAAA;AAJV;AAMQ;EACE,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,oCAAA;EACA,6BAAA;EACA,wBAAA;EACA,sBAAA;AAJV;AASM;EACE,4CAAA;AAPR;AAUI;EACE,sDAAA;EACA,yCAAA;AARN;AASM;EACE,uBAAA;AAPR;AAUQ;EACE,uBAAA;EACA,iBAAA;EACA,qBAAA;AARV;AASU;EACE,cAAA;AAPZ;AAQY;EACE,aAAA;EACA,8BAAA;AANd;AAUQ;EACE,uBAAA;EACA,yCAAA;AARV;AASU;EACE,8BAAA;AAPZ;AAUQ;EACE,uBAAA;AARV;AAUQ;EACE,gBAAA;AARV;AAUQ;EACE,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,oCAAA;EACA,6BAAA;EACA,wBAAA;EACA,sBAAA;AARV;AAaE;EACE,+BAAA;AAXJ","sourcesContent":[".test-result {\n  .ant-collapse {\n    border: none;\n    background: none;\n    border-radius: 10px;\n    box-shadow: none;\n    &-header {\n      background: rgba(0, 0, 0, 0.08);\n      border-radius: 10px;\n      padding: 10px !important;\n      border-bottom: none !important;\n      display: flex !important;\n      align-items: center !important;\n      .ant-collapse-expand-icon {\n        height: auto;\n        padding-inline-end: 8px !important;\n        span {\n          max-width: 18px;\n        }\n      }\n    }\n    &-content {\n      border: none;\n      &-box {\n        padding: 10px 10px 0 10px !important;\n      }\n    }\n    &-item {\n      border: none;\n      margin-bottom: 20px;\n      &:last-child {\n        .ant-collapse-header {\n          border-radius: 10px;\n        }\n      }\n      &-disabled {\n        .ant-collapse-header {\n          color: rgba(0, 0, 0, 0.88);\n        }\n        .ant-collapse-content {\n          display: none;\n        }\n      }\n      .ant-collapse-header[aria-disabled=\"true\"] {\n        pointer-events: none; /* 禁用 hover 效果 */\n      }\n    }\n    .ant-badge .ant-badge-count {\n      box-shadow: none;\n      background: rgba(84, 100, 160, 0.5);\n    }\n  }\n  &-collapse-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center !important;\n    font-size: 16px;\n    height: auto;\n    .anticon {\n      color: rgba(0, 0, 0, 0.4);\n      margin-right: 5px;\n      font-size: 16px;\n    }\n  }\n  &-collapse-result {\n    margin: 10px 0;\n    border: 1px solid rgba(5, 5, 5, 0.1) !important;\n    .ant-collapse-body,\n    .ant-card-body {\n      padding: 10px;\n    }\n    &-box {\n      display: flex;\n      justify-content: space-between;\n      font-size: 14px;\n    }\n    &-loading {\n      &-icon {\n        color: #8b8589;\n      }\n    }\n    &-passed {\n      border: 1px solid rgb(125, 239, 162) !important;\n      background-color: rgb(236, 253, 241) !important;\n      &-icon {\n        color: rgb(36, 190, 76);\n      }\n      &-details {\n        .ant-collapse-header {\n          background: transparent;\n          font-size: 16px;\n          padding: 0 !important;\n          &-text {\n            display: block;\n            div {\n              display: flex;\n              justify-content: space-between;\n            }\n          }\n        }\n        .ant-collapse-expand-icon {\n          height: auto !important;\n          padding-inline-end: 5px !important;\n          margin-top: 5px;\n          span {\n            max-width: 12px !important;\n          }\n        }\n        .ant-collapse-content {\n          background: transparent;\n        }\n        .ant-collapse-item {\n          margin-bottom: 0;\n        }\n        li {\n          list-style: none;\n          color: rgb(36, 190, 76);\n          font-size: 14px;\n          background: rgba(255, 255, 255, 0.5);\n          padding: 2px 5px;\n          border-radius: 6px;\n          margin-top: 3px;\n        }\n      }\n    }\n    &-collapse-badge {\n      .ant-scroll-number {\n        background: rgba(75, 85, 99, 0.5) !important;\n      }\n    }\n    &-error {\n      border: 1px solid rgb(253, 189, 191) !important;\n      background: rgb(254, 239, 239) !important;\n      &-icon {\n        color: rgb(233, 43, 53);\n      }\n      &-details {\n        .ant-collapse-header {\n          background: transparent;\n          font-size: 16px;\n          padding: 0 !important;\n          &-text {\n            display: block;\n            div {\n              display: flex;\n              justify-content: space-between;\n            }\n          }\n        }\n        .ant-collapse-expand-icon {\n          height: auto !important;\n          padding-inline-end: 5px !important;\n          span {\n            max-width: 12px !important;\n          }\n        }\n        .ant-collapse-content {\n          background: transparent;\n        }\n        .ant-collapse-item {\n          margin-bottom: 0;\n        }\n        li {\n          list-style: none;\n          color: rgb(209, 15, 29);\n          font-size: 14px;\n          background: rgba(255, 255, 255, 0.5);\n          padding: 2px 5px;\n          border-radius: 6px;\n          margin-top: 3px;\n        }\n      }\n    }\n  }\n  .ant-collapse-arrow {\n    font-size: 10px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
